import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { JobDepartmentComponent } from './components/job-department.component';
import { TreeviewModule } from '../tree-view';
import {  MatCheckboxModule } from '@angular/material/checkbox';
import { MatBadgeModule } from '@angular/material/badge';
import {  MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


@NgModule({
    declarations: [
        JobDepartmentComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        MatBadgeModule,
        MatTooltipModule,
        TreeviewModule.forRoot(),
        FontAwesomeModule,
    ],
    exports: [
        JobDepartmentComponent
    ],
})
export class JobDepartmentModule {
}
